import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "progress-bar-container progress-bar-container-streaks" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, [
  /*#__PURE__*/_createElementVNode("label", null, "Dashboard Streak")
], -1 /* HOISTED */)
const _hoisted_3 = { class: "form-input" }
const _hoisted_4 = { class: "progress-bar" }
const _hoisted_5 = { class: "streaks" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("li", { class: "streak-total" }, null, -1 /* HOISTED */)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "streak-bar" }, null, -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_checkboxIcon = _resolveComponent("checkboxIcon")!
  const _component_ToolTipComponent = _resolveComponent("ToolTipComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_ToolTipComponent, null, {
        trigger: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("ul", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.daysOfTheWeek, (day) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: day,
                  class: "streak-day"
                }, [
                  _createTextVNode(_toDisplayString(day) + " ", 1 /* TEXT */),
                  _createVNode(_component_checkboxIcon)
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ])
        ]),
        content: _withCtx(() => [
          _createElementVNode("div", null, [
            _createElementVNode("p", null, _toDisplayString(_ctx.streakHealthText), 1 /* TEXT */)
          ])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}